import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpaceDefaultNotificationSettingsKey } from '../../utils/keys';
export const useUpdateDefaultSpaceNotificationSettings = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const spaceDefaultNotificationSettingsKey = getSpaceDefaultNotificationSettingsKey();
    return useMutation(variables => client.notifications.updateSpaceDefaultNotificationSettings(variables), {
        onSettled: () => {
            // invalidate to refetch again
            queryClient.invalidateQueries(spaceDefaultNotificationSettingsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateDefaultSpaceNotificationSettings.js.map